import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AudioComponent } from './audio/audio.component';
import { VideoComponent } from './video/video.component';
import { BunnyRatingVideoComponent } from './bunny-video/bunny-video.component';

import { RatingComponent } from './rating.component';
import { HeaderComponent } from './header/header.component';
import { MediaControlComponent } from './media-control/media-control.component';
import { VoteComponent } from './vote/vote.component';
import { MediaPlayComponent } from './media-play/media-play.component';

import { SharedModule } from '../shared/shared.module';
import { RatingIntroComponent } from './intro/intro.component';
import { RatingFinishedComponent } from './rating-finished/rating-finished.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule
  ],
  providers: [
  ],
  declarations: [
    AudioComponent,
    VideoComponent,
    BunnyRatingVideoComponent,
    RatingComponent,
    HeaderComponent,
    MediaControlComponent,
    VoteComponent,
    MediaPlayComponent,
    RatingIntroComponent,
    RatingFinishedComponent,
  ]
})
export class RatingModule { }
